import React from "react";
import "./Footer.css";
import "./Footer_Responsive.css";
import { withRouter } from "react-router-dom";

//Components

const Footer = (props) => {
  const { pathname } = props.location;

  return (
    <div>
      {pathname != "/" && (
        <div className="footerContainer">
          <div>
            <svg className="svg-divider" viewBox="0 0 1920 96" version="1.1">
              <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="black"
                fillRule="evenodd"
              >
                <g id="divider1" fill="black">
                  <path
                    d="M1920,0.5 L1920,96 L0,96 L0,30.5 C196,-5.5 436.061169,0.0822995747 680.055093,14.2475678 C960,30.5 1458.02941,83.3456663 1920,0.5 Z"
                    id="Path"
                  ></path>
                </g>
              </g>
            </svg>
          </div>
          <div className="copyright">
            <span className="footer-content">
              Copyright © 2021 Willie | All rights reserved
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default withRouter(Footer);
